import { useThemeStore } from '../../stores/theme.store';

/** The light brand mark (today's, unchanged in light: D10). */
export const BRAND_LOGO_LIGHT = '/logo.webp';

/**
 * The dark brand mark David approved (2026-10-27): a lossless WebP at 3x the
 * rendered size (40 px tall, 36 px on the phone head) with the dark header's
 * background baked in, so it is not square and has no rounded corners.
 */
export const BRAND_LOGO_DARK = '/logo-dark.webp';

/**
 * The shell's brand mark (desktop top bar and phone head). The source follows
 * the resolved theme from the store, so the alt text stays on one <img> and a
 * light page never fetches the dark asset.
 */
export default function BrandLogo() {
  const dark = useThemeStore((s) => s.resolved) === 'dark';
  return (
    <img
      src={dark ? BRAND_LOGO_DARK : BRAND_LOGO_LIGHT}
      alt="EmpathEase"
      className={dark ? 'ee-brand__logo ee-brand__logo--dark' : 'ee-brand__logo'}
    />
  );
}
